import { render } from "./MainLayout.vue?vue&type=template&id=18ca20c2"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/MainLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18ca20c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18ca20c2', __exports__)) {
    api.reload('18ca20c2', __exports__)
  }
  
  module.hot.accept("./MainLayout.vue?vue&type=template&id=18ca20c2", () => {
    api.rerender('18ca20c2', render)
  })

}


export default __exports__